export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'App',
            'horizontal': 'Horizontales',
            'horizontalMenu': 'Horizontales Menü',
            'general': 'Allgemeines',
            'component': 'Komponente',
            'features': 'Eigenschaften',
            'applications': 'Anwendungen',
            'dashboard': 'Instrumententafel',
            'dashboard1': 'Instrumententafel 1',
            'dashboard2': 'Instrumententafel 2',
            'dashboard3': 'Instrumententafel 3',
            'modules': 'Modul',
            'agency': 'Agentur',
            'pages': 'Seiten',
            'gallery': 'Galerie',
            'pricing': 'Preisgestaltung',
            'terms&Conditions': 'Terms & amp Bedingungen',
            'feedback': 'Feedback',
            'report': 'Bericht',
            'faq(s)': 'Faq(s)',
            'advancedComponent': 'Erweiterte Komponente',
            'blank': 'Leer',
            'session': 'Session',
            'login': 'Anmeldung',
            'register': 'Registrieren',
            'lockScreen': 'Bildschirm sperren',
            'forgotPassword': 'Passwort vergessen',
            'uiComponents': 'UI Components',
            'alerts': 'Benachrichtigungen',
            'appBar': 'App-Leiste',
            'avatars': 'Avatare',
            'buttons': 'Tasten',
            'bottomNavigations': 'Untere Navigation',
            'badges': 'Abzeichen',
            'cards': 'Karten',
            'cardsMasonry': 'Karten Masonary',
            'chip': 'Chip',
            'dialog': 'Dialog',
            'dividers': 'Teiler',
            'drawers': 'Schubladen',
            'popover': 'Popover',
            'expansionPanel': 'Erweiterungsfeld',
            'gridList': 'Rasterliste',
            'list': 'Liste',
            'menu': 'Speisekarte',
            'popoverAndToolTip': 'Popover und Kurzinfo',
            'progress': 'Fortschritt',
            'snackbar': 'Imbissbude',
            'selectionControls': 'Auswahlkontrollen',
            'advanceUiComponents': 'Advance UI-Komponenten',
            'dateAndTimePicker': 'Datums- und Uhrzeitauswahl',
            'tabs': 'Registerkarten',
            'stepper': 'Stepper',
            'notification': 'Benachrichtigung',
            'sweetAlert': 'Süßer Alarm',
            'autoComplete': 'Auto abgeschlossen',
            'aboutUs': 'Über uns',
            'widgets': 'Widgets',
            'forms': 'Formen',
            'formElements': 'Formularelemente',
            'textField': 'Textfeld',
            'selectList': 'Wählen Sie Liste',
            'charts': 'Diagramme',
            'reCharts': 'Re Charts',
            'reactChartjs2': 'Reagiere Chartjs 2',
            'icons': 'Symbole',
            'themifyIcons': 'Themify Symbole',
            'simpleLineIcons': 'Einfache Linie Icons',
            'materialIcons': 'Materielle Ikonen',
            'fontAwesome': 'Schrift genial',
            'tables': 'Tabellen',
            'basic': 'Basic',
            'dataTable': 'Datentabelle',
            'responsive': 'Reagierend',
            'reactTable': 'Reagiert Tabelle',
            'maps': 'Karten',
            'googleMaps': 'Google Karten',
            'leafletMaps': 'Prospektkarten',
            'inbox': 'Posteingang',
            'users': 'Benutzer',
            'userProfile1': 'Benutzerprofil 1',
            'userProfile2': 'Benutzerprofil 2',
            'userManagement': 'Benutzerverwaltung',
            'userProfile': 'Benutzerprofil',
            'userList': 'Benutzerliste',
            'calendar': 'Kalander',
            'cultures': 'Kulturen',
            'dnd': 'Dnd',
            'selectable': 'Wählbar',
            'customRendering': 'Benutzerdefiniertes Rendern',
            'chat': 'Plaudern',
            'toDo': 'Machen',
            'editor': 'Editor',
            'wysiwygEditor': 'WYSIWYG-Editor',
            'quillEditor': 'Federredakteur',
            'reactAce': 'Reagiere Ace',
            'dragAndDrop': 'Ziehen und ablegen',
            'reactDragula': 'Reagiere Dragula',
            'reactDnd': 'Reagiere Dnd',
            'blogManagement': 'Blogverwaltung',
            'ecommerce': 'E-Commerce',
            'shopList': 'Geschäftsliste',
            'shopGrid': 'Ladenetz',
            'invoice': 'Rechnung',
            'multilevel': 'Mehrstufig',
            'sublevel': 'Unterebene',
            'dateTimePicker': 'Datums- und Uhrzeitauswahl',
            'user': 'Benutzer',
            'miscellaneous': 'Sonstiges',
            'promo': 'Promo',
            'gettingStarted': 'Anfangen',
            'shop': 'Geschäft',
            'cart': 'Wagen',
            'checkout': 'Auschecken',
            'saas': 'SAAS',
            'multiLevel': 'MultiLevel',
            'level1': 'Level 1',
            'level2': 'Level 2',
            'boxed': 'Verpackt',
            'news': 'Nachrichten',
            'extensions': 'Erweiterungen',
            'imageCropper': 'Bildkrämer',
            'videoPlayer': 'Videoplayer',
            'dropzone': 'Abwurfgebiet',
            'crm': 'CRM',
            'projects': 'Projekte',
            'projectDetail': 'Projektdetail',
            'clients': 'Kunden',
            'reports': 'Berichte'
        },
        'widgets': {
            'totalEarns': 'Gesamt verdient',
            'emailsStatistics': 'E-Mail-Statistiken',
            'onlineVistors': 'Online-Vistoren',
            'trafficSources': 'Zugriffsquellen',
            'RecentOrders': 'letzte Bestellungen',
            'topSellings': 'Top-Verkäufe',
            'productReports': 'Produktberichte',
            'productStats': 'Produkt Statistiken',
            'ComposeEmail': 'E-Mail verfassen',
            'ratings': 'Bewertungen',
            'employeePayroll': 'Personalabrechnung',
            'visitors': 'Besucher',
            'orders': 'Aufträge',
            'orderStatus': 'Bestellstatus',
            'totalSales': 'Gesamtumsatz',
            'netProfit': 'Reingewinn',
            'overallTrafficStatus': 'Gesamtverkehrsstatus',
            'tax': 'MwSt',
            'expenses': 'Expetenzen',
            'currentTime': 'Aktuelle Uhrzeit',
            'currentDate': 'Aktuelles Datum',
            'todayOrders': 'Heute Bestellungen',
            'toDoList': 'Aufgabenlisten',
            'discoverPeople': 'Menschen entdecken',
            'commments': 'Bemerkungen',
            'newCustomers': 'neue Kunden',
            'recentNotifications': 'Letzte Benachrichtigungen',
            'appNotifications': 'App-Benachrichtigungen',
            'newEmails': 'Neue E-Mails',
            'siteVisitors': 'Website-Besucher',
            'recentActivities': 'Kürzliche Aktivitäten',
            'recentOrders': 'letzte Bestellungen',
            'gallery': 'Galerie',
            'pricing': 'Preisgestaltung',
            'enterpriseEdition': 'Enterprise Edition',
            'personalEdition': 'Persönliche Ausgabe',
            'teamEdition': 'Teamausgabe',
            'socialCompanines': 'Soziale Unternehmen',
            'standard': 'Standard',
            'advanced': 'Fortgeschritten',
            'master': 'Meister',
            'Mega': 'Mega',
            'logIn': 'Einloggen',
            'signUp': 'Anmelden',
            'lockScreen': 'Bildschirm sperren',
            'alertsWithLink': 'Warnungen mit Link',
            'additionalContent': 'Zusätzlicher Inhalt',
            'alertDismiss': 'Alarm ablehnen',
            'uncontrolledDisableAlerts': 'Unkontrolliert Alarme deaktivieren',
            'contexualAlerts': 'Contexuelle Warnungen',
            'alertsWithIcons': 'Warnungen mit Symbolen',
            'Simple App Bars': 'Einfache App-Bars',
            'appBarsWithButtons': 'App-Bars mit Tasten',
            'imageAvatars': 'Bild-Avatare',
            'lettersAvatars': 'Buchstaben Avatare',
            'iconsAvatars': 'Ikonen Avatare',
            'flatButtons': 'Flache Tasten',
            'raisedButton': 'Raised Knopf',
            'buttonWithIconAndLabel': 'Knopf mit Ikone und Aufkleber',
            'floatingActionButtons': 'Schwimmende Aktionsschaltflächen',
            'iconButton': 'ICon-Taste',
            'socialMediaButton': 'Social-Media-Schaltfläche',
            'reactButton': 'Schaltfläche Reagieren',
            'buttonOutline': 'Schaltfläche Gliederung',
            'buttonSize': 'Knopfgröße',
            'buttonState': 'Schaltflächenstatus',
            'buttonNavigationWithNoLabel': 'Schaltfläche Navigation ohne Label',
            'buttonNavigation': 'Schaltflächennavigation',
            'iconNavigation': 'Symbol Navigation',
            'badgeWithHeadings': 'Abzeichen mit Überschriften',
            'contexualVariations': 'Contexuelle Variationen',
            'badgeLinks': 'Abzeichen Links',
            'materialBadge': 'Materialabzeichen',
            'simpleCards': 'Einfache Karten',
            'backgroundVarient': 'Hintergrund-Variante',
            'cardOutline': 'Kartenumriss',
            'overlayCard': 'Overlay-Karte',
            'cardGroup': 'Kartengruppe',
            'cardTitle': 'Kartentitel',
            'speacialTitleTreatment': 'Spezielle Titelbehandlung',
            'chipWithClickEvent': 'Chip mit Klickereignis',
            'chipArray': 'Chip-Array',
            'dialogs': 'Dialoge',
            'listDividers': 'Verteiler auflisten',
            'insetDividers': 'Ergänzung Teiler',
            'temporaryDrawers': 'Vorübergehende Schubladen',
            'permanentDrawers': 'Permanente Schubladen',
            'simpleExpansionPanel': 'Einfacher Erweiterungspanel',
            'controlledAccordion': 'Kontrolliertes Akkordeon',
            'secondaryHeadingAndColumns': 'Sekundäre Überschrift und Spalten',
            'imageOnlyGridLists': 'Bild nur Rasterlisten',
            'advancedGridLists': 'Erweiterte Grid-Listen',
            'singleLineGridLists': 'Einzellinien-Raster-Listen',
            'simpleLists': 'Einfache Listen',
            'folderLists': 'Ordnerlisten',
            'listItemWithImage': 'Artikel mit Bild auflisten',
            'switchLists': 'Listen umschalten',
            'insetLists': 'Einfügelisten',
            'nestedLists': 'Verschachtelte Listen',
            'checkboxListControl': 'Kontrollkästchen Listensteuerung',
            'pinedSubHeader': 'Pined Unterkopf',
            'InteractiveLists': 'Interaktive Listen',
            'simpleMenus': 'Einfache Menüs',
            'selectedMenu': 'Ausgewähltes Menü',
            'maxHeightMenu': 'Max Höhe Menü',
            'changeTransition': 'Übergang ändern',
            'paper': 'Papier',
            'anchorPlayGround': 'Anker Spielfeld',
            'tooltip': 'QuickInfo',
            'positionedToolTips': 'Positionierte Snackbar',
            'circularProgressBottomStart': 'Kreisförmiger Fortschritt Bottom Start',
            'interactiveIntegration': 'Interaktive Integration',
            'determinate': 'Bestimmt',
            'linearProgressLineBar': 'Lineare Fortschrittsleiste',
            'indeterminate': 'Unbestimmt',
            'buffer': 'Puffer',
            'query': 'Abfrage',
            'transitionControlDirection': 'Übergangskontrollrichtung',
            'simpleSnackbar': 'Einfache Snackbar',
            'positionedSnackbar': 'Positionierte Snackbar',
            'contexualColoredSnackbars': 'Contexual farbige Snackbars',
            'simpleCheckbox': 'Einfache Checkbox',
            'interminateSelection': 'Auswahl trennen',
            'disabledCheckbox': 'Deaktivierte Checkbox',
            'customColorCheckbox': 'Benutzerdefinierte Farbe Kontrollkästchen',
            'VerticalStyleCheckbox': 'Vertical Style Checkbox',
            'horizontalStyleCheckbox': 'Horizontal Style Checkbox',
            'radioButtons': 'Radio Knöpfe',
            'disabledRadio': 'Deaktiviertes Radio',
            'withError': 'Mit Fehler',
            'switches': 'Swisches',
            'dateAndTimePicker': 'Datum und Zeit Picker',
            'defaultPicker': 'Standardauswahl',
            'timePicker': 'ime Picker',
            'weekPicker': 'Wochenauswahl',
            'defaultDatePicker': 'Standard-Datumsauswahl',
            'customPicker': 'Benutzerdefinierte Auswahl',
            'tabs': 'Registerkarten',
            'fixedTabs': 'Feste Registerkarten',
            'basicTab': 'Grundlegende Registerkarte',
            'wrappedLabels': 'Wrapped Etiketten',
            'centeredLabels': 'Zentrierte Etiketten',
            'forcedScrolledButtons': 'Erzwungene Scroll-Schaltflächen',
            'iconsTabs': 'Ikonen-Registerkarten',
            'withDisableTabs': 'Mit Disable Registerkarten ',
            'iconWithLabel': 'Ikone mit Etikett',
            'stepper': 'Stepper',
            'horizontalLinear': 'Horizontal Linear',
            'horizontalNonLinear': 'Horizontal nicht linear',
            'horizontalLinerAlternativeLabel': 'Horizontale Liner Alternative Label',
            'horizontalNonLinerAlternativeLabel': 'Horizontaler nonliner alternativer Aufkleber',
            'verticalStepper': 'Vertikaler Stepper',
            'descriptionAlert': 'Beschreibung Warnung',
            'customIconAlert': 'Benutzerdefinierte Symbolwarnung',
            'withHtmlAlert': 'Mit HTML-Warnung',
            'promptAlert': 'Prompte Warnung',
            'passwordPromptAlert': 'Passwort Aufforderung Alert',
            'customStyleAlert': 'Benutzerdefinierte Stilwarnung',
            'autoComplete': 'Auto abgeschlossen',
            'reactSelect': 'Reagieren Auswählen',
            'downshiftAutoComplete': 'Herunterschalten Auto abgeschlossen',
            'reactAutoSuggests': 'Reagiere Auto Suggests',
            'aboutUs': 'Über uns',
            'ourVission': 'Unsere Entscheidung',
            'ourMissions': 'Unsere Missionen',
            'ourMotivation': 'Unsere Motivation',
            'defualtReactForm': 'Defaultre Reagieren Form',
            'url': 'Url',
            'textArea': 'Textbereich',
            'file': 'Datei',
            'formGrid': 'Formularraster',
            'inlineForm': 'Inline-Formular',
            'inputSizing': 'Eingabegröße',
            'inputGridSizing': 'Größe des Eingabegrids',
            'hiddenLabels': 'Versteckte Etiketten',
            'formValidation': 'Formularüberprüfung',
            'number': 'Nummer',
            'date': 'Datum',
            'time': 'Zeit',
            'color': 'Farbe',
            'search': 'Suche',
            'selectMultiple': 'Wählen Sie Mehrere',
            'inputWithSuccess': 'Eingabe mit Erfolg',
            'inputWithDanger': 'Eingabe mit Gefahr',
            'simpleTextField': 'Einfaches Textfeld',
            'componet': 'Komponenten',
            'layouts': 'Layouts',
            'inputAdorements': 'Eingabeverehrung',
            'formattedInputs': 'Formatierte Eingaben',
            'simpleSelect': 'Einfache Select',
            'nativeSelect': 'Native Auswahl',
            'MutltiSelectList': 'Mutlti Auswahlliste',
            'lineChart': 'Liniendiagramm',
            'barChart': 'Balkendiagramm',
            'stackedBarChart': 'Gestapeltes Balkendiagramm',
            'lineBarAreaChart': 'Line Bar Bereich Diagramm',
            'areaChart': 'Flächendiagramm',
            'stackedAreaChart': 'Gestapelte Flächendiagramm',
            'verticalChart': 'Vertikales Diagramm',
            'radarChart': 'Radar-Diagramm',
            'doughnut': 'Krapfen',
            'polarChart': 'Polardiagramm',
            'pieChart': 'Kuchendiagramm',
            'bubbleChart': 'Blasendiagramm',
            'horizontalBar': 'Horizonatl Bar',
            'basicTable': 'Grundtabelle',
            'contexualColoredTable': 'Contexual farbige Tabelle',
            'dataTable': 'Datentabelle',
            'employeeList': 'Mitarbeiterliste',
            'responsiveTable': 'Responsive Tabelle',
            'responsiveFlipTable': 'Responsive Flip-Tabelle',
            'reactGridControlledStateMode': 'Grid-gesteuerten Statusmodus reaktivieren',
            'googleMaps': 'Google Maps',
            'productsReports': 'Produkte Berichte',
            'taskList': 'Aufgabenliste',
            'basicCalender': 'Grundkalender',
            'culturesCalender': 'Kulturen Kalender',
            'dragAndDropCalender': 'ziehen und fallen Kalender',
            'selectableCalender': 'Wählbarer Kalender',
            'customRendering': 'Benutzerdefiniertes Rendern',
            'customCalender': 'Benutzerdefinierte Kalender',
            'searchMailList': 'Mail-Liste durchsuchen',
            'forgetPassword': 'Passwort vergessen',
            'QuickLinks': 'Schnelle Links',
            'upgrade': 'Aktualisierung',
            'app': 'App',
            'addNew': 'Neue hinzufügen',
            'orderDate': 'Auftragsdatum',
            'status': 'Status',
            'trackingNumber': 'Auftragsnummer, Frachtnummer,',
            'action': 'Sendungscode',
            'designation': 'Aktion',
            'subject': 'Bezeichnung',
            'send': 'Gegenstand',
            'saveAsDrafts': 'Senden',
            'onlineSources': 'Als Entwürfe speichern',
            'lastMonth': 'Online-Quellen',
            'widgets': 'Im vergangenen Monat',
            'listing': 'Widgets',
            'paid': 'Neue hinzufügen',
            'refunded': 'Bezahlt',
            'done': 'Zurückerstattet',
            'pending': 'Erledigt',
            'cancelled': 'steht aus',
            'approve': 'Abgebrochen',
            'following': 'Folgend',
            'follow': 'Folgen',
            'graphs&Charts': 'Grafiken und Diagramme',
            'open': 'Öffnen',
            'bounced': 'Ausgetreten',
            'spam': 'Spam',
            'unset': 'Nicht festgelegt',
            'bandwidthUse': 'Bandbreite verwenden',
            'dataUse': 'Daten verwenden',
            'unsubscribe': 'Abmelden',
            'profile': 'Profil',
            'messages': 'Mitteilungen',
            'support': 'Unterstützung',
            'faq(s)': 'Faq (s)',
            'upgradePlains': 'Upgrade-Ebenen',
            'logOut': 'Ausloggen',
            'mail': 'E-Mail',
            'adminTheme': 'Admin-Design',
            'wordpressTheme': 'Wordpress-Thema',
            'addToCart': 'In den Warenkorb legen',
            'plan': 'Planen',
            'basic': 'Basic',
            'pro': 'Profi',
            'startToBasic': 'Start zu Basic',
            'upgradeToPro': 'Upgrade auf Pro',
            'upgradeToAdvance': 'Upgrade zum Vorrücken',
            'comparePlans': 'Vergleiche Pläne',
            'free': 'Frei',
            'frequentlyAskedQuestions': 'Häufig gestellte Fragen',
            'searchIdeas': 'Ideen suchen',
            'startDate': 'Anfangsdatum',
            'endDate': 'Endtermin',
            'category': 'Kategorie',
            'apply': 'Sich bewerben',
            'downloadPdfReport': 'PDF-Bericht herunterladen',
            'yesterday': 'Gestern',
            'totalOrders': 'Gesamtbestellungen',
            'totalVisitors': 'Gesamt Besucher',
            'typeYourQuestions': 'Geben Sie Ihre Fragen ein',
            'username': 'Nutzername',
            'password': 'Passwort',
            'signIn': 'Anmelden',
            'enterYourPassword': 'Geben Sie Ihr Passwort ein',
            'alreadyHavingAccountLogin': 'Haben Sie bereits Konto Login',
            'composeMail': 'Mail schreiben',
            'issue': 'Problem',
            'recentChat': 'Kürzlicher Chat',
            'previousChat': 'Vorheriger Chat',
            'all': 'Alle',
            'filters': 'Filter',
            'deleted': 'Gelöscht',
            'starred': 'Markiert',
            'frontend': 'Vorderes Ende',
            'backend': 'Backend',
            'api': 'Api',
            'simpleAppBar': 'Einfache App-Leiste',
            'recents': 'Letzte',
            'cardLink': 'Kartenverbindung',
            'anotherLink': 'Ein weiterer Link',
            'cardSubtitle': 'subtítulo de la tarjeta',
            'confirmationDialogs': 'Bestätigungsdialoge',
            'deletableChip': 'Löschbarer Chip',
            'customDeleteIconChip': 'Benutzerdefiniertes Löschen Icon Chip',
            'openAlertDialog': 'Öffnen Sie den Benachrichtigungsdialog',
            'openResponsiveDialog': 'Offener responsiver Dialog',
            'openSimpleDialog': 'Einfaches Dialogfeld öffnen',
            'openFormDialog': 'Formular öffnen',
            'follower': 'Anhänger',
            'important': 'Wichtig',
            'private': 'Privatgelände',
            'openLeft': 'Öffnen Sie links',
            'openRight': 'Rechts öffnen',
            'openTop': 'Oben offen',
            'openBottom': 'Unten öffnen',
            'selectTripDestination': 'Wählen Sie Reiseziel',
            'pinnedSubheaderList': 'Fixierte Subheader-Liste',
            'singleLineItem': 'Einzelposten',
            'acceptTerms': 'Die Bedingungen akzeptieren',
            'optionA': 'Option A',
            'optionB': 'Option B',
            'optionC': 'Option C',
            'optionM': 'Option M',
            'optionN': 'Option N',
            'optionO': 'Option O',
            'customColor': 'Freiwählbare Farbe',
            'centeredTabs': 'Zentrierte Registerkarten',
            'multipleTabs': 'Mehrere Registerkarten',
            'preventScrolledButtons': 'Scroll-Schaltflächen verhindern',
            'browse': 'Durchsuche',
            'formValidate': 'Formvalidierung',
            'code': 'Code',
            'company': 'Unternehmen',
            'price': 'Preis',
            'change': 'Veränderung',
            'high': 'Hoch',
            'low': 'Niedrig',
            'volume': 'Lautstärke',
            'personalDetails': 'Persönliche Details',
            'occupation': 'Occupation',
            'companyName': 'Name der Firma',
            'phoneNo': 'Telefon-Nr',
            'city': 'Stadt',
            'zipCode': 'Postleitzahl',
            'updateProfile': 'Profil aktualisieren',
            'reject': 'Ablehnen',
            'exportToExcel': 'Exportieren nach Excell',
            'addNewUser': 'Neuen Benutzer hinzufügen',
            'workWeek': 'Arbeitswoche',
            'agenda': 'Agenda',
            'conference': 'Konferenz',
            'dailySales': 'Tägliche Verkäufe',
            'today': 'Heute',
            'campaignPerformance': 'Kampagnenleistung',
            'supportRequest': 'Unterstützungsanfrage',
            'usersList': 'Benutzerliste',
            'lastWeek': 'Letzte Woche',
            'buyMore': 'Kauf mehr',
            'trafficChannel': 'Verkehrskanal',
            'stockExchange': 'Börse',
            'tweets': 'Tweets',
            'ourLocations': 'Unsere Standorte',
            'sales': 'Der Umsatz',
            'to': 'Zu',
            'shipTo': 'Ausliefern',
            'description': 'Beschreibung',
            'unitPrice': 'Einzelpreis',
            'total': 'Gesamt',
            'note': 'Hinweis',
            'chipWithAvatar': 'Chip mit Benutzerbild',
            'chipWithTextAvatar': 'Chip mit Text Benutzerbild',
            'chipWithIconAvatar': 'Chip mit Symbol Benutzerbild',
            'customClickableChip': 'Kundenspezifischer anklickbarer Chip',
            'outlineChip': 'Umriss-Chip',
            'disableChip': 'Deaktivieren Sie Chip',
            'alertDialog': 'Benachrichtigungsdialog',
            'animatedSlideDialogs': 'Animierte Dia-Dialoge',
            'fullScreenDialogs': 'Vollbild-Dialoge',
            'formDialogs': 'Formulardialogfelder',
            'simpleDialogs': 'Einfache Dialoge',
            'responsiveFullScreen': 'Responsive Vollbild',
            'primary': 'Primär',
            'social': 'Sozial',
            'user': 'Benutzer',
            'admin': 'Administrator',
            'permanentdrawer': 'Dauerhafte Schublade',
            'persistentdrawer': 'Persistente Schublade',
            'swiches': 'Swisches',
            'horizontalLinearAlternativeLabel': 'Horizontaler linearer alternativer Aufkleber',
            'horizontalNonLinearAlternativeLabel': 'Horizontaler nicht linearer alternativer Aufkleber',
            'notifications': 'Benachrichtigungen',
            'basicAlert': 'Grundlegende Warnung',
            'successAlert': 'Erfolgsalarm',
            'warningAlert': 'Warnung Warnung',
            'reactAutoSuggest': 'Reagiere Auto Suggest',
            'components': 'Komponenten',
            'inputAdornments': 'Eingabeverehrung',
            'multiSelectList': 'Mehrfachauswahlliste',
            'contextualColoredTable': 'Contexual farbige Tabelle',
            'updateYourEmailAddress': 'Aktualisieren Sie Ihre E-Mail-Adresse',
            'selectADefaultAddress': 'Wählen Sie eine Standardadresse',
            'activity': 'Aktivität',
            'basicCalendar': 'Basiskalender',
            'culturesCalendar': 'Kulturen Kalender',
            'dragAndDropCalendar': 'Ziehen Sie den Kalender und legen Sie ihn ab',
            'quillEditor': 'Federredakteur',
            'reactDND': 'Reagiere DND',
            'dragula': 'Dragula',
            'AcceptorrRejectWithin': 'Akzeptieren oder ablehnen innerhalb',
            'quoteOfTheDay': 'Zitat des Tages',
            'updated10Minago': 'Vor 10 Minuten aktualisiert',
            'personalSchedule': 'Persönlicher Zeitplan',
            'activeUsers': 'Aktive Benutzer',
            'totalRequest': 'Gesamtanforderung',
            'new': 'Neu',
            'ShareWithFriends': 'Mit Freunden teilen!',
            'helpToShareText': 'Helfen Sie uns, die Welt zu verbreiten, indem Sie unsere Website mit Ihren Freunden und Followern in sozialen Netzwerken teilen!',
            'thisWeek': 'Diese Woche',
            'howWouldYouRateUs': 'Wie würdest du uns bewerten?',
            'booking': 'Buchung',
            'confirmed': 'Bestätigt',
            'monthly': 'monatlich',
            'weekly': 'Wöchentlich',
            'target': 'Ziel',
            'totalActiveUsers': 'Gesamtzahl aktiver Benutzer',
            'deadline': 'Frist',
            'team': 'Mannschaft',
            'projectManagement': 'Projektmanagement',
            'latestPost': 'Neuester Beitrag',
            'projectTaskManagement': 'Projektaufgabenverwaltung',
            'selectProject': 'Wählen Sie Projekt',
            'activityBoard': 'Aktivitätsausschuss',
            'checklist': 'Checkliste',
            'baseConfig': 'Basiskonfiguration',
            'customControlBar': 'Benutzerdefinierte Steuerleiste',
            'withDownloadButton': 'Mit dem Download-Button',
            'httpLiveStreaming': 'HTTP-Live-Streaming',
            'keyboardShortcuts': 'Tastatürkürzel',
            'preview': 'Vorschau',
            'croppedImage': 'Bild abgeschnitten',
            'totalRevenue': 'Gesamtumsatz',
            'transactionList': 'Transaktionsliste',
            'transferReport': 'Übertragungsbericht',
            'expenseCategory': 'Kostenkategorie',
            'upcomingEvents': 'Kommende Veranstaltungen',
            'OngoingProjects': 'laufende Projekte',
            'ProjectStatus': 'Projekt-Status',
            'LiveChatSupport': 'Live-Chat-Unterstützung'
        },
        'components': {
            'buyNow': 'Kaufe jetzt',
            'alreadyHavingAccountSignIn': 'Account bereits angemeldet haben',
            'enterYourPassword': 'Geben Sie Ihr Passwort ein',
            'unlock': 'Freischalten',
            'enterPasswords': 'Geben Sie Passwörter ein',
            'resestPassword': 'Passwort zurücksetzen',
            'pageNotfound': 'Seite nicht gefunden',
            'goToHomePage': 'Zur Startseite gehen',
            'sorryServerGoesWrong': 'Sorry Server geht falsch',
            'persistentDrawer': 'Persistente Schublade',
            'back': 'Zurück',
            'next': 'Nächster',
            'completeStep': 'Beende den Schritt',
            'withHtml': 'Mit HTML',
            'prompt': 'Prompt',
            'withDescription': 'Mit Beschreibung',
            'success': 'Erfolg',
            'passwordPrompt': 'Passwort Eingabeaufforderung',
            'warning': 'Warnung',
            'customIcon': 'Benutzerdefiniertes Symbol',
            'customStyle': 'Benutzerdefinierter Stil',
            'basic': 'Basic',
            'submit': 'einreichen',
            'compose': 'Komponieren',
            'sendMessage': 'Nachricht senden',
            'addNewTasks': 'Fügen Sie neue Aufgaben hinzu',
            'addToCart': 'In den Warenkorb legen',
            'payNow': 'Zahl jetzt',
            'print': 'Drucken',
            'cart': 'Wagen',
            'viewCart': 'Warenkorb ansehen',
            'checkout': 'Auschecken',
            'summary': 'Zusammenfassung',
            'yesterday': 'Gestern',
            'last7Days': 'Letzten 7 Tage',
            'last1Month': 'Letzter 1 Monat',
            'last6Month': 'Letzte 6 Monate',
            'spaceUsed': 'Speicherplatz verwendet',
            'followers': 'Anhänger',
            'trending': 'Trend',
            'paid': 'Bezahlt',
            'refunded': 'Zurückerstattet',
            'done': 'Erledigt',
            'pending': 'steht aus',
            'cancelled': 'Abgebrochen',
            'approve': 'Genehmigen',
            'week': 'Woche',
            'month': 'Monat',
            'year': 'Jahr',
            'today': 'Heute',
            'popularity': 'Popularität',
            'email': 'Email',
            'drafts': 'Entwürfe',
            'sent': 'Geschickt',
            'trash': 'Müll',
            'all': 'Alle',
            'do': 'Machen',
            'title': 'Titel',
            'projectName': 'Projektname',
            'companyName': 'Name der Firma',
            'openAlert': 'Alarm öffnen',
            'slideInAlertDialog': 'Einblenden im Benachrichtigungsdialog',
            'openFullScreenDialog': 'Öffnen Sie Vollbild-Dialoge',
            'basicChip': 'Grundlegender Chip',
            'clickableChip': 'Anklickbarer Chip',
            'left': 'links',
            'right': 'Recht',
            'expansionPanel1': 'Erweiterungskonsole 1',
            'expansionPanel2': 'Erweiterungspanel 2',
            'generalSetting': 'Allgemeine Einstellung',
            'advancedSettings': 'Erweiterte Einstellungen',
            'firstName': 'Vorname',
            'lastName': 'Familienname, Nachname',
            'occupation': 'Besetzung',
            'phoneNo': 'Telefon-Nr',
            'address': 'Adresse',
            'city': 'Stadt',
            'state': 'Zustand',
            'zipCode': 'Postleitzahl',
            'social Connection': 'Soziale Verbindung',
            'emailPrefrences': 'E-Mail Einstellungen',
            'myProfile': 'Mein Profil',
            'product': 'Produkt',
            'quantity': 'Menge',
            'totalPrice': 'Gesamtpreis',
            'removeProduct': 'Produkt entfernen',
            'mobileNumber': 'Handynummer',
            'address2Optional': 'Adresse 2 (optional)',
            'country': 'Land',
            'zip': 'Postleitzahl',
            'saveContinue': 'Speichern fortsetzen',
            'placeOrder': 'Bestellung aufgeben',
            'payment': 'Zahlung',
            'billingAddress': 'Rechnungsadresse',
            'ShippingAddressText': 'Die Lieferadresse ist die gleiche wie die Rechnungsadresse.',
            'CartEmptyText': 'Dein Einkaufswagen ist leer!',
            'NoItemFound': 'Kein Artikel gefunden',
            'goToShop': 'Zum Laden gehen',
            'cardNumber': 'Kartennummer',
            'expiryDate': 'Verfallsdatum',
            'cvv': 'CVV',
            'nameOnCard': 'Name auf der Karte',
            'confirmPayment': 'Bestätige Zahlung'
        },
        'compenets': {
            'choose': 'Wählen',
            'username': 'Nutzername',
            'passwords': 'Passwörter',
            'signIn': 'Anmelden',
            'dontHaveAccountSignUp': 'Keine Kontoanmeldung',
            'enterUserName': 'Geben Sie den Benutzernamen ein',
            'enterEmailAddress': 'E-Mail Adresse eingeben',
            'confirmPasswords': 'Bestätigen Sie die Passwörter'
        },
        'themeOptions': {
            'sidebarOverlay': 'Sidebar-Überlagerung',
            'sidebarBackgroundImages': 'Seitenleiste Hintergrundbilder',
            'sidebarImage': 'Sidebar-Bild',
            'miniSidebar': 'Mini Seitenleiste',
            'boxLayout': 'Box-Layout',
            'rtlLayout': 'Rtl-Layout',
            'darkMode': 'Dunkler Modus',
            'sidebarLight': 'Licht',
            'sidebarDark': 'Dunkel',
            'appSettings': 'App Einstellungen',
            'themeColor': 'Thema Farbe'
        },
        'button': {
            'cancel': 'Stornieren',
            'add': 'Hinzufügen',
            'update': 'Aktualisieren',
            'reply': 'Antworten',
            'delete': 'Löschen',
            'yes': 'Ja',
            'viewAll': 'Alle ansehen',
            'like': 'Mögen',
            'assignNow': 'Jetzt zuweisen',
            'seeInsights': 'Siehe Einblicke',
            'acceptTerms': 'Die Bedingungen akzeptieren',
            'reject': 'Ablehnen',
            'addNew': 'Neue hinzufügen',
            'goToCampaign': 'Gehe zur Kampagne',
            'viewProfile': 'Profil anzeigen',
            'sendMessage': 'Nachricht senden',
            'saveNow': 'Jetzt sparen',
            'pen': 'Stift',
            'search': 'Suche',
            'downloadPdfReport': 'PDF-Bericht herunterladen',
            'primary': 'Primär',
            'secondary': 'Sekundär',
            'danger': 'Achtung',
            'info': 'Info',
            'success': 'Erfolg',
            'warning': 'Warnung',
            'link': 'Verknüpfung',
            'smallButton': 'Kleiner Knopf',
            'largeButton': 'Großer Knopf',
            'blockLevelButton': 'Schaltfläche Blockieren Ebene',
            'primaryButton': 'Primärer Knopf',
            'button': 'Geschmack',
            'save': 'sparen',
            'openMenu': 'Menü öffnen',
            'openWithFadeTransition': 'Mit Fade-Übergang öffnen',
            'openPopover': 'Popover öffnen',
            'accept': 'Akzeptieren',
            'click': 'Klicken',
            'complete': 'Komplett',
            'back': 'Zurück',
            'next': 'Nächster',
            'completeStep': 'Beende den Schritt',
            'error': 'Error',
            'writeNewMessage': 'Schreibe eine neue Nachricht',
            'saveChanges': 'Änderungen speichern',
            'addNewUser': 'Neuen Benutzer hinzufügen',
            'more': 'Mehr',
            'useDefaultImage': 'Verwenden Sie Standardbild',
            'cropImage': 'Bild zuschneiden'
        },
        'hint': {
            'whatAreYouLookingFor': 'Wonach suchen Sie',
            'searchMailList': 'Mail-Liste durchsuchen'
        },
        'module': {
            'inbox': 'Posteingang',
            'drafts': 'Entwürfe',
            'sent': 'Geschickt',
            'trash': 'Müll',
            'spam': 'Spam',
            'frontend': 'Vorderes Ende',
            'backend': 'Backend',
            'api': 'Api',
            'issue': 'Problem'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {}
    }
};
